// @ts-nocheck
import CheckoutReviewAndSubmit, {
    StorePagesCheckoutReviewAndSubmitActions,
} from "@store/Framework/Store/Store/Pages/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitReducer";
import { combineReducers } from "redux";

const pagesReducers = {
    checkoutReviewAndSubmit: CheckoutReviewAndSubmit,
};

export type StorePagesActions = StorePagesCheckoutReviewAndSubmitActions;
export default combineReducers(pagesReducers);
